define('modules/videos/uw/avp-docked',[
    'jquery',
    'underscore',
    'baseview',
    'utils',
    'pubsub',
    'modules/videos/pluto/pluto-title-bar'

],
function(
    $,
    _,
    BaseView,
    Utils,
    PubSub,
    PlutoTitleBar
) {
    'use strict';

    var AVPD = BaseView.extend(
        {
            events: {},
            initialize: function(options){
                options = $.extend({
                    video: null,
                    analytics: {
                        clickedClose: 'snow-automated-video-playerclosed'
                    }
                }, options);

                BaseView.prototype.initialize.call(this, options);

                if (Utils.getNested(window.site_vars, 'html5video', 'scrollingPlayer', 'titleBar')) {
                    this.subviews.tb = new PlutoTitleBar({
                        el: this.$('.js-ptb'),
                        onClose: _.bind(this.onClose, this)
                    });
                }
                this.$el.parent().addClass('playerIsScrolling');
            },

            onClose: function() {
                PubSub.trigger('uotrack', this.options.analytics.clickedClose);
                this.destroy();
            },

            destroy: function(){
                this.el.parentNode.removeChild(this.el);
                BaseView.prototype.destroy.call(this);
            }
        }
    );

    return AVPD;

});
